module.exports = __webpack_public_path__ + "img/image_1-36a061aa.png";